import { TypePolicy } from '@apollo/client';
import { offsetLimitPagination } from '@apollo/client/utilities';

export const userWithProjectRoleResultsPolicy = {
    UserWithProjectRoleResults: {
        keyFields: ['count'],
        fields: {
            userWithProjectRoleResults: offsetLimitPagination(),
            users: {
                merge(_existing, incoming) {
                    return [...incoming];
                }

            },
        },
    } as TypePolicy,
}